import GridChartWidget from './gen2_widgets/grid_chart/GridChartWidget.lazy.jsx';
import FlipCardWidget from './gen2_widgets/flip_card/FlipCardWidget.jsx';
import CallProgressWidget from './gen2_widgets/call_progress/CallProgressWidget.jsx';
import PhaseProgressWidget from './gen2_widgets/phase_progress/PhaseProgressWidget.jsx';
import ReportStatusWidget from './gen2_widgets/report_status/ReportStatusWidget.jsx';
import ImageWidget from './gen2_widgets/image/ImageWidget.jsx';
import EmbedWidget from './gen2_widgets/embed/EmbedWidget.jsx';
import TableauWidget from './gen2_widgets/tableau/TableauWidget.jsx';
import PageEditorWidget from './gen2_widgets/page_editor/PageEditorWidget.jsx';
import EventFeedWidget from './gen2_widgets/event_feed/EventFeedWidget.jsx';
import TitleWidget from './gen2_widgets/title/TitleWidget.jsx';
import WorkflowStatusWidget from './gen2_widgets/workflow_status/WorkflowStatusWidget.jsx';
import RiskGaugeWidget from './gen2_widgets/risk_gauge/RiskGaugeWidget.jsx';
import MapVisualisationWidget from './gen2_widgets/map_visualisation/MapVisualisationWidget.jsx';
import DataStripDatasetWidget from './gen2_widgets/data_strip/DataStripDatasetWidget.jsx';
import SimplePieDatasetWidget from './gen2_widgets/simple_pie/SimplePieDatasetWidget.jsx';
import DonutWithTargetDatasetWidget from './gen2_widgets/donut_with_target/DonutWithTargetDatasetWidget.jsx';
import BarChartDatasetWidget from './gen2_widgets/bar_chart/BarChartDatasetWidget.jsx';
import CumulativeLineDatasetWidget from './gen2_widgets/cumulative_line/CumulativeLineDatasetWidget.jsx';
import TimelineWidget from './gen2_widgets/timeline/TimelineWidget.jsx';
import SDGTotalContributionWidget from './gen2_widgets/sdg_total_contribution/SDGTotalContributionWidget.jsx';
import AssignedTasksWidget from './gen2_widgets/assigned_tasks_widget/AssignedTasksWidget.jsx';
import ApplicantProjectListWidget from './gen2_widgets/applicant_project_list/ApplicantProjectListWidget.jsx';
import ApplicantReportListWidget from './gen2_widgets/applicant_report_list/ApplicantReportListWidget.jsx';
import PaymentsWidget from './gen2_widgets/payments/PaymentsWidget.jsx';
import WorkflowDataStripWidget from './gen2_widgets/workflow_data_strip/WorkflowDataStripWidget.jsx';
import ValuesAchievedDatasetWidget from './gen2_widgets/values_achieved/ValuesAchievedDatasetWidget.jsx';
import TaskStatusWidget from './gen2_widgets/task_status/TaskStatusWidget.jsx';
import MapWidget from './gen2_widgets/map/MapWidget.lazy.jsx';
import CustomChartWidget from './gen2_widgets/custom_chart/CustomChartWidget.jsx';
import TabContainerWidget from './gen2_widgets/tab_container_widget/TabContainerWidget.jsx';
import DiscussionWidget from './gen2_widgets/discussion/DiscussionWidget.jsx';
import WorkflowStatusTrackerWidget from './gen2_widgets/workflow_status_tracker/WorkflowStatusTrackerWidget.jsx';
import GaugeWidget from './gen2_widgets/gauge/GaugeWidget.jsx';
import AdvancedFilterWidget from './gen2_widgets/advanced_filter/AdvancedFilterWidget.jsx';
import ButtonFilterWidget from './gen2_widgets/button_filter/ButtonFilterWidget.jsx';
import ProjectFilterWidget from './gen2_widgets/project_filter/ProjectFilterWidget.jsx';
import ProjectListWidget from './gen2_widgets/project_list/ProjectListWidget.jsx';
import WorkflowInboxWidget from './gen2_widgets/workflow_inbox_widget/WorkflowInboxWidget.jsx';
import MyWorkQueuesWidget from './gen2_widgets/my_work_queues/MyWorkQueuesWidget.jsx';
import MyWorkWidget from './gen2_widgets/my_work/MyWorkWidget.jsx';

import GridChartWidgetSettings from './gen2_widgets/grid_chart/GridChartWidgetSettings.jsx';
import FlipCardWidgetSettings from './gen2_widgets/flip_card/FlipCardWidgetSettings.jsx';
import CallProgressWidgetSettings from './gen2_widgets/call_progress/CallProgressWidgetSettings.jsx';
import PhaseProgressWidgetSettings from './gen2_widgets/phase_progress/PhaseProgressWidgetSettings.jsx';
import ReportStatusWidgetSettings from './gen2_widgets/report_status/ReportStatusWidgetSettings.jsx';
import ImageWidgetSettings from './gen2_widgets/image/ImageWidgetSettings.jsx';
import EmbedWidgetSettings from './gen2_widgets/embed/EmbedWidgetSettings.jsx';
import TableauWidgetSettings from './gen2_widgets/tableau/TableauWidgetSettings.jsx';
import EventFeedWidgetSettings from './gen2_widgets/event_feed/EventFeedWidgetSettings.jsx';
import TitleWidgetSettings from './gen2_widgets/title/TitleWidgetSettings.jsx';
import WorkflowStatusWidgetSettings from './gen2_widgets/workflow_status/WorkflowStatusWidgetSettings.jsx';
import RiskGaugeWidgetSettings from './gen2_widgets/risk_gauge/RiskGaugeWidgetSettings.jsx';
import MapVisualisationWidgetSettings from './gen2_widgets/map_visualisation/MapVisualisationWidgetSetting.jsx';
import DataStripDatasetWidgetSettings from './gen2_widgets/data_strip/DataStripDatasetWidgetSettings.jsx';
import SimplePieDatasetWidgetSettings from './gen2_widgets/simple_pie/SimplePieDatasetWidgetSettings.jsx';
import DonutWithTargetDatasetWidgetSettings from './gen2_widgets/donut_with_target/DonutWithTargetDatasetWidgetSettings.jsx';
import BarChartDatasetWidgetSettings from './gen2_widgets/bar_chart/BarChartDatasetWidgetSettings.jsx';
import CumulativeLineDatasetWidgetSettings from './gen2_widgets/cumulative_line/CumulativeLineDatasetWidgetSettings.jsx';
import TimelineWidgetSettings from './gen2_widgets/timeline/TimelineWidgetSettings.jsx';
import SDGTotalContributionWidgetSettings from './gen2_widgets/sdg_total_contribution/SDGTotalContributionWidgetSettings.jsx';
import AssignedTasksWidgetSettings from './gen2_widgets/assigned_tasks_widget/AssignedTasksWidgetSettings.jsx';
import ApplicantProjectListWidgetSettings from './gen2_widgets/applicant_project_list/ApplicantProjectListWidgetSettings.jsx';
import ApplicantReportListWidgetSettings from './gen2_widgets/applicant_report_list/ApplicantReportListWidgetSettings.jsx';
import PaymentsWidgetSettings from './gen2_widgets/payments/PaymentsWidgetSettings.jsx';
import WorkflowDataStripWidgetSettings from './gen2_widgets/workflow_data_strip/WorkflowDataStripWidgetSettings.jsx';
import ValuesAchievedDatasetWidgetSettings from './gen2_widgets/values_achieved/ValuesAchievedDatasetWidgetSettings.jsx';
import TaskStatusWidgetSettings from './gen2_widgets/task_status/TaskStatusWidgetSettings.jsx';
import MapWidgetSettings from './gen2_widgets/map/MapWidgetSettings.jsx';
import CustomChartWidgetSettings from './gen2_widgets/custom_chart/CustomChartWidgetSettings.jsx';
import PageEditorWidgetSettings from './gen2_widgets/page_editor/PageEditorWidgetSettings.jsx';
import TabContainerWidgetSettings from './gen2_widgets/tab_container_widget/TabContainerWidgetSettings.jsx';
import DiscussionWidgetSettings from './gen2_widgets/discussion/DiscussionWidgetSettings.jsx';
import WorkflowStatusTrackerWidgetSettings from './gen2_widgets/workflow_status_tracker/WorkflowStatusTrackerWidgetSettings.jsx';
import GaugeWidgetSettings from './gen2_widgets/gauge/GaugeWidgetSettings.lazy.jsx';
import GridWidget from './gen2_widgets/grid/GridWidget.jsx';
import GridWidgetSettings from './gen2_widgets/grid/GridWidgetSettings.jsx';
import AdvancedFilterWidgetSettings from './gen2_widgets/advanced_filter/AdvancedFilterWidgetSettings.jsx';
import ButtonFilterWidgetSettings from './gen2_widgets/button_filter/ButtonFilterWidgetSettings.jsx';
import ProjectFilterWidgetSettings from './gen2_widgets/project_filter/ProjectFilterWidgetSettings.jsx';
import ProjectListWidgetSettings from './gen2_widgets/project_list/ProjectListWidgetSettings.jsx';
import WorkflowInboxWidgetSettings from './gen2_widgets/workflow_inbox_widget/WorkflowInboxWidgetSettings.jsx';
import MyWorkQueuesWidgetSettings from './gen2_widgets/my_work_queues/MyWorkQueuesWidgetSettings.jsx';
import MyWorkWidgetSettings from './gen2_widgets/my_work/MyWorkWidgetSettings.jsx';

// Loading comopnents instantly, lazy loading with skeletons inside components
export const Widgets = {
  GridChartWidget: GridChartWidget,
  FlipCardWidget: FlipCardWidget,
  CallProgressWidget: CallProgressWidget,
  PhaseProgressWidget: PhaseProgressWidget,
  ReportStatusWidget: ReportStatusWidget,
  ImageWidget: ImageWidget,
  EmbedWidget: EmbedWidget,
  TableauWidget: TableauWidget,
  PageEditorWidget: PageEditorWidget,
  EventFeedWidget: EventFeedWidget,
  TitleWidget: TitleWidget,
  WorkflowStatusWidget: WorkflowStatusWidget,
  RiskGaugeWidget: RiskGaugeWidget,
  MapVisualisationWidget: MapVisualisationWidget,
  DataStripDatasetWidget: DataStripDatasetWidget,
  SimplePieDatasetWidget: SimplePieDatasetWidget,
  DonutWithTargetDatasetWidget: DonutWithTargetDatasetWidget,
  BarChartDatasetWidget: BarChartDatasetWidget,
  CumulativeLineDatasetWidget: CumulativeLineDatasetWidget,
  TimelineWidget: TimelineWidget,
  SDGTotalContributionWidget: SDGTotalContributionWidget,
  AssignedTasksWidget: AssignedTasksWidget,
  ApplicantProjectListWidget: ApplicantProjectListWidget,
  ApplicantReportListWidget: ApplicantReportListWidget,
  PaymentsWidget: PaymentsWidget,
  WorkflowDataStripWidget: WorkflowDataStripWidget,
  ValuesAchievedDatasetWidget: ValuesAchievedDatasetWidget,
  TaskStatusWidget: TaskStatusWidget,
  MapWidget: MapWidget,
  CustomChartWidget: CustomChartWidget,
  TabContainerWidget: TabContainerWidget,
  DiscussionWidget: DiscussionWidget,
  WorkflowStatusTrackerWidget: WorkflowStatusTrackerWidget,
  GaugeWidget: GaugeWidget,
  GridWidget: GridWidget,
  AdvancedFilterWidget: AdvancedFilterWidget,
  ButtonFilterWidget: ButtonFilterWidget,
  ProjectFilterWidget: ProjectFilterWidget,
  ProjectListWidget: ProjectListWidget,
  WorkflowInboxWidget: WorkflowInboxWidget,
  MyWorkQueuesWidget: MyWorkQueuesWidget,
  MyWorkWidget: MyWorkWidget
};

export const WidgetSettings = {
  GridChartWidget: GridChartWidgetSettings,
  FlipCardWidget: FlipCardWidgetSettings,
  CallProgressWidget: CallProgressWidgetSettings,
  PhaseProgressWidget: PhaseProgressWidgetSettings,
  ReportStatusWidget: ReportStatusWidgetSettings,
  ImageWidget: ImageWidgetSettings,
  EmbedWidget: EmbedWidgetSettings,
  TableauWidget: TableauWidgetSettings,
  EventFeedWidget: EventFeedWidgetSettings,
  TitleWidget: TitleWidgetSettings,
  WorkflowStatusWidget: WorkflowStatusWidgetSettings,
  RiskGaugeWidget: RiskGaugeWidgetSettings,
  MapVisualisationWidget: MapVisualisationWidgetSettings,
  DataStripDatasetWidget: DataStripDatasetWidgetSettings,
  SimplePieDatasetWidget: SimplePieDatasetWidgetSettings,
  DonutWithTargetDatasetWidget: DonutWithTargetDatasetWidgetSettings,
  BarChartDatasetWidget: BarChartDatasetWidgetSettings,
  CumulativeLineDatasetWidget: CumulativeLineDatasetWidgetSettings,
  TimelineWidget: TimelineWidgetSettings,
  SDGTotalContributionWidget: SDGTotalContributionWidgetSettings,
  AssignedTasksWidget: AssignedTasksWidgetSettings,
  ApplicantProjectListWidget: ApplicantProjectListWidgetSettings,
  ApplicantReportListWidget: ApplicantReportListWidgetSettings,
  PaymentsWidget: PaymentsWidgetSettings,
  WorkflowDataStripWidget: WorkflowDataStripWidgetSettings,
  ValuesAchievedDatasetWidget: ValuesAchievedDatasetWidgetSettings,
  TaskStatusWidget: TaskStatusWidgetSettings,
  MapWidget: MapWidgetSettings,
  CustomChartWidget: CustomChartWidgetSettings,
  PageEditorWidget: PageEditorWidgetSettings,
  TabContainerWidget: TabContainerWidgetSettings,
  DiscussionWidget: DiscussionWidgetSettings,
  WorkflowStatusTrackerWidget: WorkflowStatusTrackerWidgetSettings,
  GaugeWidget: GaugeWidgetSettings,
  GridWidget: GridWidgetSettings,
  AdvancedFilterWidget: AdvancedFilterWidgetSettings,
  ButtonFilterWidget: ButtonFilterWidgetSettings,
  ProjectFilterWidget: ProjectFilterWidgetSettings,
  ProjectListWidget: ProjectListWidgetSettings,
  WorkflowInboxWidget: WorkflowInboxWidgetSettings,
  MyWorkQueuesWidget: MyWorkQueuesWidgetSettings,
  MyWorkWidget: MyWorkWidgetSettings
};

export const widgetsNoTitle = ['EmbedWidget', 'ImageWidget', 'PageEditorWidget', 'TableauWidget', 'FlipCardWidget', 'MapVisualisationWidget', 'TabContainerWidget', 'TitleWidget'];
export const widgetWithDatasource = ['DataStripDatasetWidget', 'DonutWithTargetDatasetWidget', 'SimplePieDatasetWidget', 'BarChartDatasetWidget',
  'CumulativeLineDatasetWidget', 'TimelineWidget', 'ValuesAchievedDatasetWidget', 'WorkflowDataStripWidget', 'CustomChartWidget', 'MapWidget', 'GaugeWidget', 'GridWidget', 'ButtonFilterWidget']
export const widgetsNoSettings = [];
export const widgetsNoDatasetOutput = ['MapWidget'];
export const widgetsWithCharts = ['CustomChartWidget'];
export const widgetsWithGridView = ['CustomChartWidget', 'DataStripDatasetWidget', 'MapWidget', 'GridWidget'];